export const Modals = {
  CREATE_EVENT_MODAL: 'createEventModal',
  ON_BOARDING_MODAL: 'onBoardingModal',
  BUY_RECEIPT_SCANS_MODAL: 'buyReceiptScansModal',
  BUY_EVENTS_MODAL: 'buyEventsModal',
  SCAN_RECEIPT_MODAL: 'scanReceiptModal',
};

export const VK_APP_ID = 8003899;

export const MIN_AMOUNT = 0.01;
export const MAX_PAYMENT_AMOUNT = 99999999999;//99 999 999 999
export const MAX_AMOUNT = Math.trunc(Number.MAX_SAFE_INTEGER / 100);//90 071 992 547 409
export const VK_RETARGETING_CODE = 'VK-RTRG-1733076-5Zq6K';

export const EVENT_STATUS = {
  PAYMENTS: 'payments',
  REPAYMENTS: 'repayments',
  ALL: 'all',
  ARCHIVED: 'archived',
};